import { render } from "./ktTopicCheck.vue?vue&type=template&id=7f32a9d2&scoped=true"
import script from "./ktTopicCheck.vue?vue&type=script&lang=js"
export * from "./ktTopicCheck.vue?vue&type=script&lang=js"

import "./ktTopicCheck.vue?vue&type=style&index=0&id=7f32a9d2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f32a9d2"]])

export default __exports__